// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"715":"cd827b8ed64e5ff2d719","828":"d33b50858494108d9c13"}[chunkId] + ".js";
};